export const environment =
{
    production: true,
    //apiURL: "aHR0cHM6Ly9leHRpbmd1ZS1hdXRoZW50aWNhdGlvbi1kbmdjYXZleWNxYnVkNmNqLndlc3R1cy0wMS5henVyZXdlYnNpdGVzLm5ldC9hcGkvdjEv",
    apiURL: "aHR0cHM6Ly9wcm9kLWV4dGluZ3VlLWVycC1hdXRoLmF6dXJld2Vic2l0ZXMubmV0L2FwaS92MS8=",
    //extingueURL: "aHR0cHM6Ly9leHRpbmd1ZS1zZXJ2aWNlcy1ocGR3Z3hhdmIyY3JnY2F0Lndlc3R1cy0wMS5henVyZXdlYnNpdGVzLm5ldC9hcGkvdjEv",
    extingueURL: "aHR0cHM6Ly9wcm9kLWV4dGluZ3VlLWVycC1hcGkuYXp1cmV3ZWJzaXRlcy5uZXQvYXBpL3YxLw==",
    Ambiente: '',
    encryptionType: 'AES-ENC',
    aesKey: 'NjhEQ0U1RkVFQzcwMUY5ODYxOUYxQURDRDE0NzE5Njg=',
    transformActive: true,
    firebaseConfig: {
      apiKey: "AIzaSyDPJ7iIk22ov6m1_zKyBPVBiSmr7W1dCZw",
      authDomain: "extingue-8eba9.firebaseapp.com",
      projectId: "extingue-8eba9",
      storageBucket: "extingue-8eba9.firebasestorage.app",
      messagingSenderId: "902833471943",
      appId: "1:902833471943:web:04ff7390740b770ca8d9e2",
      measurementId: "G-VYKSWM7557"
    }
};
